import { IDevice, Device } from "./device.model";
import { IStreetBuilding, StreetBuilding } from "./street-building.model";

export interface IHouseFlat {
  houseFlatId: string;
  streetBuildingId: string;
  number: string;
  fullName: string;
  residentTypeId?: string;
  phone: string;
  notes: string;
  doNotDisturb: boolean;
  packageModule: boolean;
  chatModule: boolean;
  status: boolean;
  bookingModule: boolean;
  surveysModule: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  devices?: IDevice[];
  streetBuilding?: IStreetBuilding;
}

export class HouseFlat {
  houseFlatId: string;
  streetBuildingId: string;
  number: string;
  fullName: string;
  residentTypeId?: string;
  phone: string;
  notes: string;
  doNotDisturb: boolean;
  packageModule: boolean;
  chatModule: boolean;
  status: boolean;
  bookingModule: boolean;
  surveysModule: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: Date;
  updatedAt: Date;
  devices: Device[];
  streetBuilding?: StreetBuilding;

  constructor(data: IHouseFlat) {
    this.houseFlatId = data.houseFlatId;
    this.streetBuildingId = data.streetBuildingId;
    this.number = data.number;
    this.fullName = data.fullName;
    this.residentTypeId = data.residentTypeId;
    this.phone = data.phone;
    this.notes = data.notes;
    this.doNotDisturb = data.doNotDisturb ?? false;
    this.packageModule = data.packageModule ?? true;
    this.chatModule = data.chatModule;
    this.status = data.status;
    this.bookingModule = data.bookingModule;
    this.surveysModule = data.surveysModule;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
    this.devices = data.devices
      ? data.devices.map((device) => new Device(device))
      : [];
    this.streetBuilding = data.streetBuilding
      ? new StreetBuilding(data.streetBuilding)
      : undefined;
  }

  get totalDevices(): number {
    return this.devices.length;
  }

  get totalDevicesActive(): number {
    return this.devices.filter(device => device.status).length;
  }

  get totalDevicesInactive(): number {
    return this.devices.filter(device => !device.status).length;
  }
}
